// Blog Email Capture — Listmonk lead capture for blog/radar pages
// Works for both slim (top) and full (bottom) sections
(function() {
  function initCapture(container) {
    var input = container.querySelector('input[type="email"]');
    var btn = container.querySelector('button[data-capture-btn]');
    var msg = container.querySelector('[data-capture-msg]');
    var endpoint = btn.getAttribute('data-endpoint');
    var source = btn.getAttribute('data-source');
    var blog = btn.getAttribute('data-blog') || '';
    var successMsg = btn.getAttribute('data-success');
    var btnLabel = btn.getAttribute('data-label');

    if (!input || !btn || !msg) return;

    function doSubmit() {
      var email = (input.value || '').trim().toLowerCase();
      if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        input.classList.add('is-error');
        msg.textContent = 'Please enter a valid email.';
        msg.className = msg.className.replace(/--success|--error/g, '') + '--error';
        return;
      }
      input.classList.remove('is-error');
      btn.disabled = true;
      btn.textContent = '...';
      fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email, source: source, blog: blog, page_url: window.location.href })
      })
      .then(function(r) { return r.json(); })
      .then(function() {
        msg.textContent = successMsg;
        msg.className = msg.className.replace(/--success|--error/g, '') + '--success';
        input.value = '';
        btn.textContent = btnLabel;
        btn.disabled = false;
      })
      .catch(function() {
        msg.textContent = successMsg;
        msg.className = msg.className.replace(/--success|--error/g, '') + '--success';
        input.value = '';
        btn.textContent = btnLabel;
        btn.disabled = false;
      });
    }

    btn.addEventListener('click', doSubmit);
    input.addEventListener('keydown', function(e) {
      if (e.key === 'Enter') { e.preventDefault(); doSubmit(); }
    });
    input.addEventListener('input', function() {
      input.classList.remove('is-error');
      msg.textContent = '';
    });
  }

  function initAll() {
    document.querySelectorAll('[data-blog-capture]').forEach(initCapture);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
